import { forwardRef } from "react";
import { Button } from "@/components/ui/button";

// ONE BUTTON STYLE FOR EVERY CLICKABLE CHOICE (his call, 23 Oct): "Pick what this number is…", "Not needed", "Copy",
// "this tag is the assembly's own" and the rest looked like plain text. A border, a box at least 36 px tall, words and
// an icon, a press effect — the same on Ask AI, the part page and Identify. Solid colour stays for the buttons that
// put a number on the part. A source test fails the build if one of these goes back to plain text.
const TONES = {
  plain: "border-slate-300 text-slate-700 hover:border-slate-500 hover:bg-slate-50",
  danger: "border-red-200 text-[#B01E28] hover:border-[#B01E28] hover:bg-red-50",
  sky: "border-sky-300 text-sky-800 hover:border-sky-600 hover:bg-sky-50",
  amber: "border-amber-300 text-amber-900 bg-amber-50 hover:border-amber-500 hover:bg-amber-100",
  go: "border-sky-700 bg-sky-700 text-white hover:bg-sky-800 hover:border-sky-800",
};

export const CHOICE_CLASS = "h-9 min-h-9 rounded-lg border-[1.5px] bg-white px-3 text-xs font-semibold shadow-sm "
  + "active:translate-y-px transition-[background-color,border-color,transform] disabled:opacity-50";

export const ChoiceButton = forwardRef(({ tone = "plain", className = "", children, ...props }, ref) => (
  <Button ref={ref} type="button" size="sm" variant="outline" data-choice="1"
    className={`${CHOICE_CLASS} ${TONES[tone] || TONES.plain} ${className}`} {...props}>
    {children}
  </Button>
));
ChoiceButton.displayName = "ChoiceButton";
